import { useMeClaimsRawApi } from './claimsApi';
/**
 * Returns true or false based on whether the passed feature flag
 * exists in the returned claims data.
 *
 * > NOTE: This **only** serves feature flags from the API (via
 * claims on the user's profile). It does not serve feature flags
 * from the URL. For a more general hook, see `useIsFeatureFlagEnabled`.
 *
 * @deprecated use [useIsFeatureFlagEnabled](../../hooks/useIsFeatureFlagEnabled.ts)
 * for a more complete feature flagging tool.
 */
export const useIsApiFeatureFlagEnabled = (
/** The feature flag to look for, ie: "CommsHub" */
featureName) => {
    var _a, _b;
    const claimApi = useMeClaimsRawApi();
    const featureFlagList = (_b = (_a = claimApi.data) === null || _a === void 0 ? void 0 : _a.pages) === null || _b === void 0 ? void 0 : _b.flat(1).filter(item => (item === null || item === void 0 ? void 0 : item.key) ===
        'http://schemas.msrc.microsoft.com/identity/claims/feature');
    const data = !!(featureFlagList === null || featureFlagList === void 0 ? void 0 : featureFlagList.find(data => (data === null || data === void 0 ? void 0 : data.value) === featureName));
    return Object.assign(Object.assign({}, claimApi), { data });
};
